import React from "react";
import {
  Switch,
  Route,
  BrowserRouter,
  Link,
  useLocation,
} from "react-router-dom";
import { Login } from "./Views/Login";
import { Start } from "./Views/Start";
import { AddPlayer } from "./Views/AddPlayer";
import "./App.css";
import { Players } from "./Views/Players";
import { Layout } from "antd";
import { Menu } from "antd";
import { appState } from "./appState";
import { observer } from "mobx-react";

const { Header, Content } = Layout;

const AppMenu = observer(() => {
  const location = useLocation();
  const isAdmin =
    appState.user?.uid === "EgoOmqK9MwY346XFgNd5ojGC8e12" || appState.user?.uid === "0mHcOfojpNfiwzTVnIAcaJO0ijI3" ||
    appState.user?.uid === "qiTSfKaWsYSuVo4ZJ22yQRGjvuU2";

  return (
    <Menu
      theme="dark"
      mode="horizontal"
      defaultSelectedKeys={["/"]}
      selectedKeys={[location.pathname]}
    >
      <Menu.Item key="/">
        <Link to="/">SUMMERING</Link>
      </Menu.Item>
      {isAdmin && (
        <>
          <Menu.Item key="/entry-add">
            <Link to="/entry-add">NYA BÖTER</Link>
          </Menu.Item>
          <Menu.Item key="/players-add">
            <Link to="/players-add">NY SPELARE</Link>
          </Menu.Item>
        </>
      )}
    </Menu>
  );
});

const App = observer(() => {
  return (
    <BrowserRouter>
      <div className="App">
        <Layout className="layout">
          <Header>
            <AppMenu />
          </Header>
          <Content style={{ padding: "20px" }}>
            <Switch>
              <Route path="/entry-add" exact component={Start} />
              <Route path="/players-add" component={AddPlayer} exact />
              <Route path="/" component={Players} exact />
              <Route path="/login" component={Login} />
            </Switch>
            {appState.user ? undefined : <Link to="/login" style={{ padding: 20, display: "block" }}>Logga in</Link>}
          </Content>
        </Layout>
      </div>
    </BrowserRouter>
  );
})

export default App;
